import store from '@packs/pages/charts/index/components/view/edit/store'
import('./controls.css')
export default function Controls(){
    BaseConstructor.call(this)
    let context = this
    let refresh_list = [5,10,15,30,60]

    let elements = {}

    this.generate = () =>{
        elements.container = this.createElement('div', 'view-controls-wrapper')
        elements.select_period_container = this.createElement('div')
        elements.select_refresh_container = this.createElement('div')
        elements.config_button_container = this.createElement('div')
        elements.close_button_container = this.createElement('div')
        generatePediodSelect()
        generateRefreshSelect()
        generateConfigButton()
        generateCloseButton()

        $(elements.container).append(elements.select_period_container,elements.select_refresh_container, elements.config_button_container, elements.close_button_container)
        return elements.container
    }

    function generatePediodSelect(){
        let wrapper = context.createElement('div', 'flex flex-v-center flex-h-center view-controls-control-wrapper')
        let icon = context.createElement('div', 'view-controls-control-icon-container', '<i class="far fa-clock"></i>')
        let input = context.createElement('input', 'time-control-input')
        let now = function getCurrentMoment() {
            return moment();
        }
        $(wrapper).append(icon, input)
        $(elements.select_period_container).html(wrapper)

        let dateRangePicker = $(input).daterangepicker({
            locale: {format: 'DD/M/YYYY HH:mm'},
            timePicker: true,
            startDate: now().startOf('day'),
            endDate: now().endOf('day'),
            showCustomRangeLabel:false,
            ranges:{
                'Últimos 30 minutos': [30, now()],
                'Últimas 1 Hora': [60,now()],
                'Últimas 3 Horas': [60*3,now()],
                'Últimas 6 Horas': [60*6,now()],
                'Últimas 12 Horas': [60*12,now()],
                'Últimas 24 Horas': [60*24,now()],
                'Últimos 2 dias': [60*48, now()],
                'Últimos 7 dias': [60*24*7, now()]
            }
        }, function(start, end, label){
            store.setPeriod(start)
            context.trigger('date-control-change')
        })

        dateRangePicker.on('apply.daterangepicker', function(ev, picker) {
            var selectedRangeLabel = picker.chosenLabel; // Get the label of the selected range
            $(input).val(selectedRangeLabel); // Update input value
        });

        $(input).val('Últimas 12 Horas')

        // store.setPeriod(moment().subtract(24, 'hours'), moment())
    }

    function generateRefreshSelect(){
        const generateInnerText = (value) =>{
            return `${value>=60?value/60:value}${value >= 60 ? 'h' : 'm' }`
        }
        let wrapper = context.createElement('div', 'flex flex-v-center flex-h-center view-controls-control-wrapper')
        let icon = context.createElement('div', 'view-controls-control-icon-container', '<i class="fas fa-sync-alt"></i>')
        let el = context.createElement('select', 'refresh-select')
        refresh_list.forEach(refresh_value=>{
            let option = context.createElement('option')
            option.value = refresh_value
            option.innerHTML = generateInnerText(refresh_value)
            $(el).append(option)
        })

        $(wrapper).append(icon, el)
        $(elements.select_refresh_container).append(wrapper)

        $(el).on('change', e =>{
            store.setRefreshOptionsProp('time', e.target.value)
        })

        $(el).val(store.getRefreshOptionsProp('time') || 30)

    }

    function generateConfigButton(){
        let wrapper = context.createElement('div', 'flex flex-v-center flex-h-center view-controls-control-wrapper')
        let el = context.createElement('button', 'view-controls-button-config', '<i class="fas fa-cog"></i>')
        el.type = 'button'

        $(el).on('click', () =>{
            context.trigger('config-button:click')
        })

        $(wrapper).append(el)

        $(elements.config_button_container).append(wrapper)
    }

    function generateCloseButton(){
        let wrapper = context.createElement('div', 'flex flex-v-center flex-h-center')
        let el = context.createElement('button', 'view-controls-button-config', '<i class="fas fa-times"></i>')
        el.type = 'button'

        $(el).on('click', _=>{
            context.trigger('close-button:click')
        })

        $(wrapper).append(el)

        $(elements.close_button_container).append(wrapper)
    }
}

Controls.prototype = Object.create(BaseConstructor.prototype)